"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABLE_DOMAIN = void 0;
exports.AVAILABLE_DOMAIN = [
    'ladprao21.com',
    'chokchai4.com',
    'rentspree.com',
    'rsp-qa.dev',
    'dev.rentspree.dev',
    'uat.rentspree.dev',
];
//# sourceMappingURL=constant.js.map